import { sanitizeHtml } from "utils";

import styles from "./RichText.module.scss";

interface RichTextProps {
  className?: string;
  rawHtml?: string;
  sanitizeOptions?: Parameters<typeof sanitizeHtml>[1];
}

function RichText({ rawHtml, className, sanitizeOptions = {} }: RichTextProps) {
  return (
    <div className={styles.container}>
      {rawHtml && (
        <div
          className={className}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(rawHtml, sanitizeOptions) as string,
          }}
        />
      )}
    </div>
  );
}

export default RichText;
